import { useParams, useSearchParams } from 'react-router-dom';
import { SEO_KEYWORDS, SEO_NO_LAYOUT_KEY, SEO_NO_MEDIUM_KEY } from '../constants/seo.keywords';
import { SEARCH_PARAM_KEY_TYPE } from '../constants/searchParamKeys';
export const useSEOKeywords = () => {
    const [searchParams] = useSearchParams();
    const { medium } = useParams();
    const mediumKey = medium ?? SEO_NO_MEDIUM_KEY;
    const layoutKey = searchParams.get(SEARCH_PARAM_KEY_TYPE) ?? SEO_NO_LAYOUT_KEY;
    return {
        mediumKey,
        layoutKey,
        ...SEO_KEYWORDS[mediumKey][layoutKey]
    };
};
